const { Core, Utils, onBlazeLoad } = Global;
const { $active } = Utils;

const CN_ACTIVE = '!active';

customElements.define('accordion-with-images', class extends Core {
    elements = {
        $: [['thumbnail']],
        slider: 'slideshow-blaze'
    }

    render() {
        const [ firstThumbnail ] = this.$('thumbnail', {
            click: this._handleThumbnailClick
        })

        this._setActiveThumbnail(firstThumbnail)
        onBlazeLoad(this._handleSlider.bind(this));
    }

    _handleThumbnailClick({ currentTarget }) {
        this._setActiveThumbnail(currentTarget);
    }

     async _handleSlider() {
        await customElements.whenDefined(this.elements.slider);
        this.$('slider').slider.onSlide(this._handleSlideChange.bind(this))
    }

    _handleSlideChange(index) {
      const activeThumb = this.$('thumbnail')[index];
      this._setActiveThumbnail(activeThumb);  
    }

    _setActiveThumbnail(current) {
        if(current === this.activeItem) return;
        this.activeItem && $active(this.activeItem, false);
        this.activeItem = current;
        $active(this.activeItem);
        const index = this.activeItem.getAttribute("data-index");
        this.$('slider')?.slideTo(index);
    }
})